
import React, {useState} from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import {connectionError} from '../login/userSlice';
import {FormValidator, ShowValidation } from '../utils/validation/FormValidator';
import {PasswordField, PasswordConfirmationField} from '../utils/validation/auth/AuthValidators';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import styles from '../styles/login/LoginForm.module.css';
import ErrorMessage from '../elements/ErrorMessage';
import useInputState from '../hooks/forms/useInputState';

const ConfirmPasswordForm = (props) => {
    const {email, token, tryLogin, changeStep} = props;
    const [isLoading, editIsLoading] = useState(false);
    const [hasError, editHasError] = useState(false);
    const [password, editPassword, resetPassword] = useInputState("");
    const [passwordConfirmation, editPasswordConfirmation, resetPasswordConfirmation] = useInputState("");
    const [completed, editCompleted] = useState(false);
    const dispatch = useDispatch();


    //load validation rules for fields
    const ValidationRules = {
        password: PasswordField,
        passwordConfirmation: {rule: PasswordConfirmationField, param: password}
    };

    //blur validation
    function validateFieldOnBlur(e){
        const value = e.target.value;
        const id= e.target.id;
        let res;
        if (typeof ValidationRules[id] == 'object') {
            res = ValidationRules[id].rule(value, ValidationRules[id].param);
        } else {
            res = ValidationRules[id](value);
        }
        ShowValidation(id, res);
    }

    const handleCompleted = () => {
        tryLogin(true);
        changeStep('email');
    }   

    const handlePasswordUpdate = async (e) => {
        e.preventDefault();
        let validForm = FormValidator('confirmPasswordForm', ValidationRules); 
        if (validForm) {
            editIsLoading(true);
            try{
                editHasError(false);
                const response = await axios({
                    method: "post",
                    url: process.env.NEXT_PUBLIC_API + "/api/reset-password",
                    data: {
                        email: email,
                        verification_code: token,
                        password: password,
                        password_confirmation: passwordConfirmation
                    },
                    headers: {'Content-Type': 'application/json'}
                });
                editIsLoading(false);
                if (response.data.status==true) {
                   editCompleted(true);
                   dispatch(connectionError(false));
                } else {
                   editHasError(response.data.error);
                }
                
            } catch(err) {
                editIsLoading(false);
                editHasError("Ups, avem o problemă. Te rugăm să încerci mai târziu.");
            }
        }


    }

    const spinner = isLoading &&  <><Spinner as="span" animation="grow" size="sm" role="status"
                                    aria-hidden="true" />
                                    Te rugăm să aștepți...
                                    </>;
    const btnDisabled = isLoading && 'disabled';
    const resetPasswordBtn =  <Button variant="secondary" type="submit" className="col-12" disabled={btnDisabled}  >
    {spinner}
    {!isLoading && 'Schimbă parola'}
    </Button>;

    const errorMessage = hasError && <div className="mb-3">
                        <ErrorMessage title="Eroare" message={hasError} />
                        </div>; 

    const successMsg = <Alert variant="success" className="text-center">
                            <p>Parola a fost schimbata cu succes.</p>
                            <Button onClick={handleCompleted}>Conectează-te</Button>
                        </Alert>;
    const infoMsg = hasError ? errorMessage :
                        <p className={styles.wizzardTitle}>
                            Parola trebuie să aibă minim 6 caractere.
                        </p>;

    const form = <>
                {infoMsg}
                <Form id="confirmPasswordForm" onSubmit={handlePasswordUpdate}>
                    <Form.Group controlId="password">
                        <Form.Label className={styles.login}>Noua Parolă</Form.Label>
                        <Form.Control type="password" name="password"  
                            onChange={editPassword} 
                            value={password} 
                            onBlur={validateFieldOnBlur}
                            
                        />
                        <Form.Text className="helper" as="div">    
                        </Form.Text>
                    </Form.Group>

                    <Form.Group controlId="passwordConfirmation">
                        <Form.Label className={styles.login}>Repetă Parola</Form.Label>
                        <Form.Control type="password" name="password_confirmation" 
                            onChange={editPasswordConfirmation} 
                            value={passwordConfirmation} 
                            onBlur={validateFieldOnBlur}
                            
                        />
                        <Form.Text className="helper" as="div">    
                        </Form.Text>
                    </Form.Group>  
                {resetPasswordBtn}
                </Form>
                </>;

    return(
        <>  
            { completed ? successMsg : form }    
        </>
    );

}

export default ConfirmPasswordForm;